import { useMemo, useState } from 'react';
import { useFormContext } from 'react-hook-form';

export const useFormInputState = ({ name }) => {
  const { getValues } = useFormContext();

  const [isFilled, setIsFilled] = useState(false);

  useMemo(() => {
    if (getValues(name) !== '') {
      setIsFilled(true);
    } else {
      setIsFilled(false);
    }
  }, [getValues(name)]);

  return {
    isFilled
  };
};
